// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kuPH","type":"styles_type__2NQds","choices":"styles_choices__jbWdZ"};